import {createMultiStyleConfigHelpers} from '@chakra-ui/react'
import {remCalc} from '../../_utils'

const helpers = createMultiStyleConfigHelpers(['errorPage'])
const ErrorAndMaintenancePage = helpers.defineMultiStyleConfig({
    baseStyle: {
        errorPage: {
            pageContainer: {
                w: '100%',
                h: '100vh',
                display: 'flex',
                flexDirection: 'column',
                paddingX: 0,
                paddingY: remCalc(80),
                justifyContent: {
                    base: 'flex-start',
                    lg: 'center',
                },
                alignItems: 'center',
                gap: {
                    base: remCalc(24),
                    sm: remCalc(24),
                    md: remCalc(36),
                    lg: remCalc(36),
                },
                flex: {
                    base: '1 0 0',
                    sm: '1 0 0',
                    md: 'auto',
                    lg: 'auto',
                },
                alignSelf: 'stretch',
                bg: 'background.brand',
            },
            messageContainer: {
                flexDirection: {
                    base: 'column',
                    sm: 'column',
                    md: 'column',
                    lg: 'row',
                },
                w: '100%',
                h: 'auto',
                maxWidth: '80%',
                maxHeight: '56%',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: remCalc(36),
            },
            messageTextContainer: {
                height: 'auto',
                flexDir: 'column',
                alignItems: {
                    base: 'center',
                    sm: 'center',
                    md: 'flex-start',
                    lg: 'flex-start',
                },
                gap: remCalc(32),
                flexShrink: 0,
                color: 'text.inverse',
                flex: '1',
            },
            messageTitle: {
                textStyle: 'head-xlarge',
                fontWeight: 'medium',
                textAlign: {
                    base: 'center',
                    sm: 'center',
                    md: 'left',
                    lg: 'left',
                },
            },
            messageText: {
                textStyle: 'body-xxlarge',
                fontWeight: 'normal',
                textAlign: {
                    base: 'center',
                    sm: 'center',
                    md: 'left',
                    lg: 'left',
                },
            },
            imageContainer: {
                w: '100%',
                h: '100%',
                maxHeight: remCalc(450),
                flexShrink: 0,
                flex: '1',
            },
            imageElement: {
                w: '100%',
                h: '100%',
            },

            goBackButton: {
                alignSelf: {
                    base: 'center',
                    sm: 'center',
                    md: 'flex-start',
                    lg: 'flex-start',
                },
            },
        },
    },
})

export default ErrorAndMaintenancePage
